<div class="card">
  <div class="card-header">Erro 404</div>
  <div class="card-body d-flex justify-content-center">
    <img class="my-7" src="assets/bt/img/erro-404-port.svg">
  </div>
</div>
